import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    overflowX: 'auto',
    position: 'relative',
    scrollbarWidth: 'none',
    scrollSnapType: 'both mandatory',
    '&::-webkit-scrollbar': {
      height: 0,
    },
    '& > div[data-last="true"]': {
      scrollSnapAlign: 'start',
    },
  },
  arrowContainer: {
    top: 0,
    zIndex: 10,
    height: '100%',
    cursor: 'pointer',
    position: 'sticky',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: theme.typography.pxToRem(166),
    '&[data-display="true"]': {
      display: 'flex',
    },
    '&[data-display="false"]': {
      display: 'none',
    },
  },
  arrowLeft: {
    left: 0,
    background: theme.palette.scrollable.arrowLeft.background,
  },
  arrowRight: {
    right: 0,
    background: theme.palette.scrollable.arrowRight.background,
  },
  arrow: {
    paddingLeft: theme.typography.pxToRem(5),
    fontSize: `${theme.typography.pxToRem(48)} !important`,
  },
}))
